import { actionTypes, mutationTypes, getterTypes } from '../../types';
// viewState Handler watches mutations which have to result to a viewState change
// like poping and deleting Messages

export default store => {
	let timeoutID;

	function resetTimer() {
		window.clearTimeout(timeoutID);
		startTimer();
	}
	function resetWebClient() {
		// load landing Article of exhibition maybe more action to be added
		store.dispatch(actionTypes.setArticle, {
			articleID: store.getters[getterTypes.currentExhibition].landingExhibitID,
		});
		startTimer();
	}
	function startTimer() {
		timeoutID = window.setTimeout(
			resetWebClient,
			store.state.dataSourceCFG.configLoanerDevice.inActivityIntervall * 1000
		);
	}
	// Listen on user inputs to reset Timer
	function setupListeners() {
		window.addEventListener('mousedown', resetTimer, false);
		window.addEventListener('keypress', resetTimer, false);
		window.addEventListener('DOMMouseScroll', resetTimer, false);
		window.addEventListener('mousewheel', resetTimer, false);
		window.addEventListener('touchstart', resetTimer, false);
	}

	store.subscribe((mutation, state) => {
		if (mutation.type === mutationTypes.isLoaner) {
			if (state.dataSourceCFG.configLoanerDevice.resetAfterInactivity) {
				setupListeners();
				startTimer();
			}
		}
		if (mutation.type === mutationTypes.setArticleID) {
			// Article is loaded may be from outside (AR Enginge) count as user input
			if (state.isLoaner && state.dataSourceCFG.configLoanerDevice.resetAfterInactivity) {
				resetTimer();
			}
		}
	});
};
